__turbopack_context__.v({
  "container": "R4UDsG_container",
  "cta": "R4UDsG_cta",
  "description": "R4UDsG_description",
  "desktopChart": "R4UDsG_desktopChart",
  "input": "R4UDsG_input",
  "mobileChart": "R4UDsG_mobileChart",
  "selectSum": "R4UDsG_selectSum",
  "suggestedSums": "R4UDsG_suggestedSums",
});
